import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { queryDepartTreeList, getUserList, queryUserByDepId as _queryUserByDepId, queryUserRoleMap as _queryUserRoleMap } from '@/api/api';
export default {
  name: 'JSelectUserByDepModal',
  components: {},
  props: ['modalWidth'],
  data: function data() {
    return {
      queryParam: {
        username: ""
      },
      columns: [{
        title: '用户账号',
        align: 'center',
        dataIndex: 'username'
      }, {
        title: '真实姓名',
        align: 'center',
        dataIndex: 'realname'
      }, {
        title: '角色名称',
        align: 'center',
        dataIndex: 'roleName'
      }, {
        title: '性别',
        align: 'center',
        dataIndex: 'sex',
        customRender: function customRender(text) {
          if (text === 1) {
            return '男';
          } else if (text === 2) {
            return '女';
          } else {
            return text;
          }
        }
      }, {
        title: '手机号码',
        align: 'center',
        dataIndex: 'phone'
      }, {
        title: '邮箱',
        align: 'center',
        dataIndex: 'email'
      }],
      scrollTrigger: {},
      dataSource: [],
      selectedKeys: [],
      userNameArr: [],
      departName: '',
      userRolesMap: {},
      title: '根据部门选择用户',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      selectedRowKeys: [],
      selectedRows: [],
      departTree: [],
      visible: false,
      form: this.$form.createForm(this)
    };
  },
  created: function created() {
    // 该方法触发屏幕自适应
    this.resetScreenSize();
    this.queryUserRoleMap();
  },
  methods: {
    loadData: function loadData(arg) {
      var _this = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      getUserList(params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;

          _this.assignRoleName(_this.dataSource);

          _this.ipagination.total = res.result.total;
        }
      });
    },
    queryUserRoleMap: function queryUserRoleMap() {
      var _this2 = this;

      _queryUserRoleMap().then(function (res) {
        if (res.success) {
          _this2.userRolesMap = res.result;

          _this2.loadData();
        }
      });
    },
    // 触发屏幕自适应
    resetScreenSize: function resetScreenSize() {
      var screenWidth = document.body.clientWidth;

      if (screenWidth < 500) {
        this.scrollTrigger = {
          x: 800
        };
      } else {
        this.scrollTrigger = {};
      }
    },
    showModal: function showModal() {
      this.visible = true;
      this.assignRoleName(this.dataSource);
      this.queryDepartTree();
      this.form.resetFields();
    },
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField: function getQueryField() {
      var str = 'id,';

      for (var a = 0; a < this.columns.length; a++) {
        str += ',' + this.columns[a].dataIndex;
      }

      return str;
    },
    searchReset: function searchReset(num) {
      var that = this;

      if (num !== 0) {
        that.queryParam = {};
        that.loadData(1);
      }

      that.selectedRowKeys = [];
      that.userNameArr = [];
      that.selectedKeys = [];
    },
    close: function close() {
      this.searchReset(0);
      this.visible = false;
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' === sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.loadData();
    },
    handleSubmit: function handleSubmit() {
      var that = this;

      for (var i = 0, len = this.selectedRowKeys.length; i < len; i++) {
        this.getUserNames(this.selectedRowKeys[i]);
      }

      that.$emit('ok', that.userNameArr.join(','));
      that.close();
    },
    // 遍历匹配,获取用户真实姓名
    getUserNames: function getUserNames(rowId) {
      var dataSource = this.dataSource;

      for (var i = 0, len = dataSource.length; i < len; i++) {
        if (rowId === dataSource[i].id) {
          this.userNameArr.push(dataSource[i].realname);
        }
      }
    },
    // 点击树节点,筛选出对应的用户
    onSelect: function onSelect(selectedKeys) {
      if (selectedKeys[0] != null) {
        this.queryUserByDepId(selectedKeys); // 调用方法根据选选择的id查询用户信息

        if (this.selectedKeys[0] !== selectedKeys[0]) {
          this.selectedKeys = [selectedKeys[0]];
        }
      }
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    onSearch: function onSearch() {
      this.loadData(1);
    },
    // 根据选择的id来查询用户信息
    queryUserByDepId: function queryUserByDepId(selectedKeys) {
      var _this3 = this;

      _queryUserByDepId({
        id: selectedKeys.toString()
      }).then(function (res) {
        if (res.success) {
          _this3.dataSource = res.result;
          _this3.ipagination.total = res.result.length;

          _this3.assignRoleName(_this3.dataSource);
        }
      });
    },
    // 传入用户id,找到匹配的角色名称
    queryUserRole: function queryUserRole(userId) {
      var map = this.userRolesMap;
      var roleName = [];

      for (var key in map) {
        if (userId === key) {
          roleName.push(map[key]);
        }
      }

      return roleName.join(',');
    },
    queryDepartTree: function queryDepartTree() {
      var _this4 = this;

      queryDepartTreeList().then(function (res) {
        if (res.success) {
          _this4.departTree = res.result;
        }
      });
    },
    // 为角色名称赋值
    assignRoleName: function assignRoleName(data) {
      var userId = '';
      var role = '';

      for (var i = 0, length = data.length; i < length; i++) {
        userId = this.dataSource[i].id;
        role = this.queryUserRole(userId);
        this.dataSource[i].roleName = role;
      }
    },
    modalFormOk: function modalFormOk() {
      this.loadData();
    }
  }
};